export default {
  home: {
    minute: 'minuto',
    price_info: '{mianfei} minutos grátis, máximo por dia {currencyName}{fengding}, depósito {currencyName}{yajin}, aluguel grátis',
    feature_1: 'Design especial para carregamento sem fio',
    feature_2: 'Empréstimo e pagamento universal nacional',
    feature_3: 'Quatro modos de carregamento, adequados para todos os celulares',
    submit: 'Recarregar',
    borrow: 'Emprestar',
    inputcodetitle: 'Por favor, insira o número do dispositivo no armário',
    msg_rentcount: 'Você tem atualmente {zujieNum} pedidos que não estão fechados',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    msg_fail_title: 'Erro',
    msg_fail_content: 'Falha no aluguel, por favor tente novamente',
    shoptime: 'Horário Comercial',
    supportrental: 'Suporta aluguel',
    supportreturn: 'Suporta devolução',
    useragreen: 'Clique para concordar com o "Formulário de Autorização de Débito Delegado", "Contrato do Usuário", "Contrato de Recarga"',
    privacyagreen: 'Clique para concordar com o Acordo de Privacidade',
    offline: 'O dispositivo {devicecode} está offline, por favor contate o pessoal presente',
    permissionfail: 'Permissão negada.',
    unbound: 'O código QR mix {devicecode} não está vinculado ao dispositivo',
    nobattery: 'Nenhuma bateria disponível no dispositivo {devicecode}',
    gomap: 'Ver estação próxima'
  },
  loginborrow: {
    powerbanktitle: 'DESBLOQUE O SEU BANCO MOOVENERGYPOWER',
    loginwith: 'Entrar com',
    msg_fail_title: 'Erro',
    msg_fail_user: 'Erro ao obter informações do usuário. Você quer tentar novamente?',
    msg_rentcount: 'Você tem atualmente {zujieNum} pedidos que não estão fechados',
    msg_fail_support: 'O sistema não é suportado',
    msg_fail_confirm: 'Confirmar',
    msg_fail_retry: 'Tentar novamente',
    msg_fail_cancel: 'Cancelar',
    msg_fail_order: 'Falha ao criar ordem de locação',
    msg_fail_paymod: 'Falha ao obter método de pagamento',
    msg_fail_login: 'Falha no login',
    Apple: 'Apple',
    otheropt: 'Outras opções',
    selectmethod: 'Selecione seu método de pagamento',
    paymentdetail: 'Detalhes do método de pagamento',
    couponcode: 'Código de cupom',
    rent: 'Confirmar Pagamento',
    pricing: 'Ver preços',
    phone: 'Telefone',
    Google: 'Google',
    Facebook: 'Facebook',
    loginfb: 'Entrar com o Facebook',
    logingg: 'Entrar com o Google',
    captcha_code: 'Código',
    phonenumber: 'Digite seu número de telefone',
    msg_fail_code: 'Por favor, insira o código de verificação',
    msg_fail_phone: 'Por favor, insira seu número de telefone',
    logout: 'Sair da conta',
    savenow: 'Salvar agora',
    delete: 'Deletar',
    addcard: 'Inserir detalhes do cartão',
    msg_fail_content: 'Falha no aluguel, por favor tente novamente',
    title: 'Por favor, confirme a autorização',
    policy: 'Política.',
    term: ' Termos e Condições',
    and: 'e',
    privacy: 'Política de Privacidade.',
    tips: 'Ao continuar, você concorda com nossa ',
    cancel: 'CANCELAR',
    agree: 'CONCORDAR',
    openinbrowser: 'Por favor, abra no navegador',
    localtip1: 'REVOLVER A BATERIA A QUALQUER ESTAÇÃO DE ENERGIA MOOV',
    localtip2: 'Para localizar uma estação próxima, consultar o mapa ou escanear o QR no Power Bank.'
  },
  preauth: {
    preauthortitle: 'Sobre a pré-autorização',
    tip1: 'Ao iniciar um aluguel, uma pré-autorização é feita no seu método de pagamento. Isso é apenas para garantir que há fundos suficientes disponíveis para pagar pelo seu aluguel.',
    tip2: 'Seu banco pode enviar uma notificação, mas não é uma cobrança: apenas o preço do seu aluguel será cobrado.',
    tip3: 'Dependendo do seu banco, pode levar algumas horas até alguns dias para o valor ser ajustado em seus extratos, isso é normal.'
  },
  rentcost: {
    rentcosttitle: 'Quanto custa o aluguel?',
    tip1: 'Se você não devolver o power bank dentro de 48 horas, será cobrada uma taxa de não devolução de {currency} {yajin} .',
    tip2: 'A duração é arredondada para a meia hora mais próxima (30 ou 60 minutos).',
    tip3: 'Um dia de aluguel é 24 horas a partir do momento em que o power bank é alugado.',
    tip4: 'Alguns locais podem oferecer algumas horas grátis ou descontos. Aproveite!',
    Days: 'Dias',
    Hours: 'Horas',
    Minutes: 'Minutos'
  },
  logincode: {
    login: 'Login',
    retry: 'Reenviar'
  },
  agreenconfirm: {
    title: 'Por favor, confirme a autorização',
    policy: 'Política.',
    term: 'Termos & Condições da MoovEnergy',
    and: 'e',
    privacy: 'Política de Privacidade.',
    tips: 'Eu concordo com ',
    cancel: 'CANCELAR',
    agree: 'CONCORDAR'
  },
  users: {
    username: 'nome de utilizador',
    mobile: 'telefone',
    login: 'Login',
    orders: 'Ordem de arrendamento',
    wallet: 'carteira',
    joinus: 'Colaborar para aderir',
    langsetting: 'Configuração do idioma'
  },
  login: {
    phonenumber: 'Número de telefone',
    verificationcode: 'Código de verificação',
    Rentpowerbank: 'Alugar um power bank',
    Rentpowerbanktip: 'Digite seu número de celular para começar',
    phone_number: 'Por favor, insira um número de celular com {0} dígitos',
    captcha_code: 'Código',
    send_code: 'Enviar Código',
    login: 'Login',
    agree: 'Ao clicar em Login, você concorda com ',
    readme: `Contrato do Usuário`,
    msg_fail_login: 'Falha no login',
    msg_success_login: 'Login bem-sucedido',
    msg_success_login_code: 'Recebido com sucesso, por favor baixe o APP para fazer login e usar',
    msg_fail_user: 'Erro ao obter informações do usuário. Você quer tentar novamente?',
    no_sms: 'Não recebeu mensagem de texto',
    retry: 'Reenviar',
    receive: 'Aplicar',
    invite_pwd: 'Código de convite',
    vip_agreen_tip: 'Ao continuar, você indica que aceita nosso',
    vip_agreen_service: 'Termos de Serviço',
    vip_agreen_and: 'e',
    vip_agreen_policy: 'Política de Privacidade'
  },
  confirm: {
    title: 'Confirmação de Pagamento',
    pay_label: 'Montante',
    addcard: 'Adicionar Cartão na Carteira',
    price_tips: 'Clique para confirmar o pagamento, indicando que você leu e concordou com o ',
    price_btn: '《Acordo de Valor Agregado》',
    pay_type: 'Por favor, selecione seu método de pagamento preferido',
    submit: 'Confirmar aluguel',
    charge: 'Confirmar recarga',
    msg_fail_title: 'Aviso',
    msg_fail_order: 'Falha ao criar ordem de locação',
    msg_fail_confirm: 'Confirmar',
    msg_fail_retry: 'Tentar novamente',
    msg_fail_cancel: 'Cancelar'
  },
  mine: {
    title: 'Perfil do Usuário',
    wallet: 'Minha Carteira',
    balance: 'Meu Saldo',
    mywalletcard: 'Meu Cartão',
    addcard: 'Adicionar Cartão na Carteira',
    deposit: 'Depósito',
    wallet_in: 'Recarregar',
    wallet_out: 'Retirar',
    wallet_log: 'Registro da Carteira',
    order: 'Ordem',
    login_tips: 'Por favor, faça login',
    msg_fail_title: 'Erro',
    msg_fail_user: 'Erro ao obter informações do usuário. Você quer tentar novamente?',
    help: 'Ajuda',
    setting: 'Configuração',
    logout: 'Sair',
    unpaid: 'Não pago',
    using: 'Em uso'
  },
  msg: {
    appnolaunched: 'O aplicativo ainda não foi lançado oficialmente',
    none_code: 'Código não existe',
    sms_fail: 'Falha no envio de SMS',
    unlogin: 'Você ainda não fez login, por favor faça login',
    msg_fail_title: 'Aviso',
    deletecard: 'Você tem certeza que deseja deletar este cartão?',
    loading: 'Carregando...',
    title: 'Dicas',
    success: 'Operação bem-sucedida',
    error: 'Erro desconhecido, por favor tente novamente mais tarde.',
    roleerror: 'Permissões insuficientes, por favor consulte o administrador',
    neterror: 'Falha na conexão de rede. Por favor, tente novamente mais tarde',
    confirm: 'Confirmar',
    retry: 'Tentar novamente',
    cancel: 'Cancelar',
    msg_logout: 'Você tem certeza que deseja sair da conta?',
    vieworder: 'Ver ordem',
    addorselectcard: 'Por favor, adicione ou selecione um pacote de cartão para continuar',
    success_payment: 'Pagamento concluído',
    fail_payment: 'Falha no pagamento',
    keyword: 'palavra-chave',
    unpaid_order: 'Existem ordens não pagas',
    go_pay: 'Ir pagar',
    no_more: 'não mais',
    noshop: 'Sem comerciantes',
    msg_fail_code: 'Por favor, insira o código de verificação',
    msg_fail_phone: 'Por favor, insira seu número de telefone',
    exceedorder: 'Você já tem uma ordem sob locação, por favor devolva antes de continuar'
  },
  result: {
    title: 'Aluguel confirmado',
    tips: 'Para ver pedidos e outros locais MoovEnergy, por favor baixe o App.',
    download: 'BAIXAR',
    msg_result_loading: 'O resultado do pagamento está sendo confirmado...',
    msg_tips_loading: 'A bateria portátil está aparecendo, por favor aguarde pacientemente...'
  },
  result_msg: {
    loading: 'Carregando...',
    refresh: 'Atualizar'
  },
  setting: {
    title: 'Configuração',
    lang: 'Idioma'
  },
  help: {
    title: 'FAQ'
  },
  wallet_in: {
    title: 'incremento',
    price_label: 'Seleccione outra quantidade de recarga',
    price_placeholder: 'Indique o valor acrescentado',
    balance: 'Saldo corrente',
    chargemoney: 'Seleccione por favor a quantidade de recarga',
    submit: 'Confirmar a recarga',
    loading: 'Carregamento...',
    msg_title: 'prompt'
  },
  wallet_out: {
    title: 'Retirada do saldo',
    price_label: 'Indique o valor da retirada',
    price_placeholder: 'Indique o valor da retirada',
    balance: 'Saldo corrente',
    balance_all: 'Extrair Tudo',
    deposit: 'depósito',
    deposit_tips: 'Existem atualmente pedidos sob locação, e o depósito {pccurrencyName} {pyajin} não é reembolsável atualmente',
    submit: 'Retirada imediata',
    apply: 'Pedido de retirada',
    confirm: 'confirmar',
    loading: 'Carregamento...',
    msg_fail_price: 'Montante de retirada incorreto',
    msg_fail_balance: 'O valor da retirada não pode ser maior do que o saldo atual',
    msg_title: 'erro',
    msg_success_content: 'Pedido de retirada com sucesso',
    tips_title: 'explicar',
    btn: 'Enviar',
    error_tips: 'Indique a informação completa'
  },
  nearby: {
    rent: 'Empréstimos',
    return: 'Pode ser devolvido',
    here: 'Vá aqui'
  }
}
